import { IonCard, IonCardContent, IonCol, IonLabel, IonRow, IonText } from '@ionic/react';

import HR from '../../layouts/HR';

import './Comment.css';

interface Props {
    title: string,
    date: string,
    text: string,
    reply?: string,
    isBuyer?: boolean
}

const Comment: React.FC<Props> = (props) => {
    return (
        <IonCard className="comment-item">
            <IonCardContent>
                <IonRow>
                    <IonCol>
                        <IonLabel className="title ion-float-right">{props.title}</IonLabel>
                        <IonLabel className="date ion-float-left">{props.date}</IonLabel>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonText className="comment">{props.text}</IonText>
                        {props.reply!.length > 0 ?
                            <>
                                <HR />
                                <IonText className="reply"><strong>پاسخ مدیر:</strong> {props.reply}</IonText>
                            </>
                            : null}
                    </IonCol>
                </IonRow>
            </IonCardContent>

            {props.isBuyer! ? <IonLabel className="buyer ion-float-left">خریدار محصول</IonLabel> : null}
        </IonCard>
    )
}

export default Comment